import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import { Flex } from '@chakra-ui/react'
import { TooltipCell } from '../ToolTipCell'
import { camelToWords } from '@/utils/stringHelper'

const TextCell = ({ cell: { getValue } }) => <TooltipCell text={getValue()} />

export default TextCell
